<template>
  <el-dialog
    :model-value="store.decisionPendiente"
    title="Hay filas con errores"
    width="460px"
    :before-close="store.cerrarDecision"
  >
    <p class="masiva-decision__text">
      El archivo tiene
      <strong>{{ correctas }} {{ correctas === 1 ? 'correcta' : 'correctas' }}</strong>
      y
      <strong>{{ store.filasErroneas.length }} con error</strong>. ¿Cómo querés continuar?
    </p>
    <p class="masiva-decision__hint">
      Si procesás solo las correctas, las filas con error no se cotizan y podrás descargarlas luego
      para corregirlas. Podés cerrar esta ventana para seguir revisando la tabla.
    </p>
    <template #footer>
      <el-button
        data-test="cancelar-carga"
        @click="store.cancelarCarga()"
        >Cancelar carga</el-button
      >
      <el-button
        data-test="procesar-correctos"
        type="primary"
        :disabled="!correctas"
        @click="procesarCorrectos"
        >Procesar solo los registros correctos</el-button
      >
    </template>
  </el-dialog>
</template>

<script setup>
import { computed } from 'vue';
import { useCotizacionMasivaStore } from '../stores/cotizacion_masiva_store.js';
import { useMasivaProcesar } from '../composables/use_masiva_procesar.js';

const store = useCotizacionMasivaStore();
const { procesar } = useMasivaProcesar();

const correctas = computed(() => store.filasCorrectas.length);

const procesarCorrectos = () => {
  store.decisionPendiente = false;
  return procesar();
};
</script>

<style scoped>
.masiva-decision__text {
  margin: 0 0 8px;
  color: #1f2937;
}

.masiva-decision__hint {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
</style>
